export class Organograma {
  constructor({
    id = null,
    nome = null,
    sigla = null,
    ativo = null,
    secretariaExecutiva = null,
    setores = [],
    profissionais = [],
  }) {
    this.id = id;
    this.nome = nome;
    this.sigla = sigla;
    this.ativo = ativo;
    this.secretariaExecutiva = secretariaExecutiva;
    this.setores = setores;
    this.profissionais = profissionais;
  }
  static Build() {
    return new Organograma({
      id: null,
      nome: null,
      sigla:null,
      ativo: null,
      secretariaExecutiva: null,
      setores: [],
      profissionais: [],
    });
  }
  format() {
    this.setores = this.setores.map((p) => p.id);
    return this;
  }
}
